import { z } from 'zod';

export const telegramAuthSchema = z.object({
  initData: z.string().min(1),
});

// Telegram Login Widget callback payload — see
// https://core.telegram.org/widgets/login#receiving-authorization-data
// Hash is HMAC-SHA256 of the rest of the fields, with `SHA256(bot_token)` as
// the secret key (this is different from the Mini App's `WebAppData` HMAC).
export const telegramWidgetAuthSchema = z.object({
  id: z.number().int(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  username: z.string().optional(),
  photo_url: z.string().optional(),
  auth_date: z.number().int(),
  hash: z.string().min(1),
});

export const emailLoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
});

// Username format: 3–30 chars, latin letters / digits / underscore. Case is
// NOT enforced here (mixed case is accepted as input) — the backend lowercases
// on store and uniqueness is case-insensitive (see services/username.ts).
export const usernameSchema = z.string().min(3).max(30).regex(/^[a-zA-Z0-9_]+$/);

export const emailRegisterSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6).max(128),
  firstName: z.string().min(1).max(100),
  lastName: z.string().min(1).max(100),
  username: usernameSchema,
});

export const appleAuthSchema = z.object({
  identityToken: z.string().min(10),
  // Apple only sends user object on FIRST authentication. Mobile passes
  // it through if available so we can populate firstName / lastName.
  user: z.object({
    firstName: z.string().max(80).optional(),
    lastName: z.string().max(80).optional(),
  }).optional(),
});

export type AppleAuthInput = z.infer<typeof appleAuthSchema>;

export const googleAuthSchema = z.object({
  idToken: z.string().min(10),
});
export type GoogleAuthInput = z.infer<typeof googleAuthSchema>;

export const refreshTokenSchema = z.object({
  refreshToken: z.string().min(1),
});

export const pushTokenSchema = z.object({
  expoToken: z.string().min(10).max(200).regex(/^ExponentPushToken\[/),
  platform: z.enum(['ios', 'android']),
});
export type PushTokenInput = z.infer<typeof pushTokenSchema>;
